/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFooterColumnFragment} from '@amblique/contentful/app/contentful/fragments/footer-column/base-footer-column.fragment';
import {BaseLinkFragment} from '@amblique/contentful/app/contentful/fragments/link/base-link.fragment';

export const FooterColumnFragment = gql`
  ${BaseFooterColumnFragment}
  ${BaseLinkFragment}

  fragment FooterColumnFragment on FooterColumn {
    ...BaseFooterColumnFragment

    linksCollection {
      items {
        __typename
        ... on Link {
          ...BaseLinkFragment
        }
      }
    }
  }
`;
